export type LiveOpsCurrency = { id: string, name: string, mediaUrl: string }

export enum LIVE_OPS_EVENT_TEMPLATE_FAMILY {
  PATHWAY = 'pathway',
  TEST = 'test',
}

export type CurrencyAmount = {
  currency: string
  amount: number
}

export type LiveOpsEventTemplate = {
  id: string
  name: string
  eventId: string
  variationId: string
  duration: number
  packageUrl: string
  packageId?: string
  mainIconBackgroundColor: string
  mainIconUrl: string
  mainColor: string
  cosmetic?: Record<string, unknown>
  rewards: string[]
  costs: string[]
  config: {
    family: LIVE_OPS_EVENT_TEMPLATE_FAMILY.PATHWAY
    steps: {
      name: string
      costs: CurrencyAmount[]
      rewards: CurrencyAmount[]
    }[]
  } | {
    family: LIVE_OPS_EVENT_TEMPLATE_FAMILY.TEST
    steps2: {
      name: string
      costs: CurrencyAmount[]
      rewards: CurrencyAmount[]
    }[]
  }
}

export type LiveOpsEventTemplateSpecificConfig<Family extends LIVE_OPS_EVENT_TEMPLATE_FAMILY> = Extract<LiveOpsEventTemplate['config'], { family: Family }>

export enum LiveOpsLeaderboardType {
  EVENT_COMPLETION = 'eventCompletion',
  REWARDED_CURRENCY = 'rewardedCurrency',
}

export type LiveOpsLeaderboard = {
  id: string
  name: string
  mainEventTemplateId: string
  startTimestamp: number
  endTimestamp: number
  prizePool: { fromRank: number, toRank: number, prize: CurrencyAmount }[]
  config: {
    type: LiveOpsLeaderboardType.EVENT_COMPLETION
  } | {
    type: LiveOpsLeaderboardType.REWARDED_CURRENCY
    currency: string
  }
  mainColor?: string
  mainIconUrl?: string
  rules?: string
  description?: string
}

export type LiveOpsUserEvent = {
  id: string
  eventTemplateId: string
  eventId: string
  variationId: string
  isComplete: boolean
  startTimestamp: number
  endTimestamp: number
} & (
  {
    eventFamily: LIVE_OPS_EVENT_TEMPLATE_FAMILY.PATHWAY
    state: {
      currentStep: number
    }
  } |
  {
    eventFamily: LIVE_OPS_EVENT_TEMPLATE_FAMILY.TEST
    state: {
      test: number
    }
  }
  )
